<template>
    <div>
        <div class="upload-list">
            <div v-for="(item, index) in fileList" :key="index" style="display: flex;">
                <div class="item-box img-box" v-if="isImage(item.url)">
                    <el-image :src="item.url" :preview-src-list="[item.url]"
                        :style="{ 'width': width + 'px', 'height': height + 'px' }" />
                    <div class="img-btn-box" :style="{ 'width': width + 'px', 'height': height + 'px' }">
                        <i class="el-icon-zoom-in" @click.stop="onPreview(item.url)"></i>
                        <i class="el-icon-delete" @click.stop="handelRemove(item.url)"></i>
                    </div>
                    <div class="file-name">{{ item.trainingName }}</div>
                </div>
                <div class="item-box img-box" v-else-if="isVideo(item.url)">
                    <video :src="item.url" :style="{ 'width': width + 'px', 'height': height + 'px' }" controls></video>
                    <div class="img-btn-box" :style="{ 'width': width + 'px', 'height': height + 'px' }">
                        <i class="el-icon-zoom-in" @click.stop="onPreview(item.url)"></i>
                        <i class="el-icon-delete" @click.stop="handelRemove(item.url)"></i>
                    </div>
                    <div class="file-name">{{ item.trainingName }}</div>
                </div>
                <div class="item-box file-box" v-else-if="isDocument(item.url)">
                    <div class="file-info" :style="{ 'width': width + 'px', 'height': height + 'px' }">
                        <i class="el-icon-document-checked" style="font-size: 100px;"></i>
                        <span class="name">{{
                            fileNames[index] }}</span>
                    </div>
                    <div class="file-btn-box" :style="{ 'width': width + 'px', 'height': height + 'px' }">
                        <i class="el-icon-zoom-in" @click.stop="onFilePreview(item.url)"></i>
                        <i class="el-icon-delete" @click.stop="handelRemove(item.url)"></i>
                    </div>
                    <div class="file-name">{{ item.trainingName }}</div>
                </div>
                <el-upload v-else class="avatar-uploader" :action="$uploadURL" :on-success="handleSuccess"
                    :before-upload="beforeUpload" :show-file-list="false" :multiple="false">
                    <i v-if="limit >= fileList.length" slot="trigger" class=" avatar-uploader-icon"
                        :class="accept === 'img' ? 'el-icon-plus' : 'el-icon-upload'"
                        :style="{ 'width': width + 'px', 'height': height + 'px' }"></i>
                </el-upload>
            </div>
            <el-upload class="avatar-uploader" :action="$uploadURL" :on-success="handleSuccess"
                :before-upload="beforeUpload" :show-file-list="false" :multiple="false">
                <i v-if="limit > fileList.length" slot="trigger" class=" avatar-uploader-icon"
                    :class="accept === 'img' ? 'el-icon-plus' : 'el-icon-upload'"
                    :style="{ 'width': width + 'px', 'height': height + 'px' }"></i>
            </el-upload>
        </div>
        <el-dialog title="预览图片" :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="预览文件" :visible.sync="dialogFileVisible" append-to-body width="1200px" top="3vh"
            class="pdf_dialog">
            <iframe :src="previewUrl" width="100%" height="100%;"></iframe>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFileVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="视频播放" :visible.sync="dialogVideoVisible" append-to-body width="65%">
            <video ref="videoRef" :src="previewVideoUrl" controls style="width: 100%;height: 100%;">
                你的浏览器不支持 video 标签。
            </video>
        </el-dialog>
    </div>
</template>

<script>
/* 
type form 中文件的对象
fileUrls 用于回显[url1,url2]
*/
export default {
    props: {
        uploadUrl: {
            type: String,
            default: ''
        },
        accept: {
            type: String,
            default: 'img'
        },
        width: {
            type: Number,
            default: 140
        },
        height: {
            type: Number,
            default: 140
        },
        multiple: {
            type: Boolean,
            default: true
        },
        fileUrls: {
            type: Array,
            default: () => []
        },
        limit: {
            type: Number,
            default: 1
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            fileList: [],
            dialogImageUrl: '',
            dialogVisible: false,
            fileNames: [],
            dialogFileVisible: false,
            previewUrl: '',
            previewVideoUrl: '',
            dialogVideoVisible: false
        };
    },
    watch: {
        fileList: {
            handler(newVal) {
                //遍历数组，获取文件名
                this.fileNames = newVal.map(item => {
                    const fileName = item.url.substring(item.url.lastIndexOf('/') + 1);
                    const maxLength = 15; // 最大显示长度

                    if (fileName.length <= maxLength) {
                        return fileName;
                    }

                    // 计算前后保留的字符数，中间用省略号代替
                    const frontLength = Math.ceil(maxLength / 2);
                    const endLength = Math.floor(maxLength / 2) - 1; // 减1是为了给省略号留位置

                    return `${fileName.substring(0, frontLength)}...${fileName.substring(fileName.length - endLength)}`;
                });
            },
            immediate: true
        },
        fileUrls: {
            handler(newVal) {
                // 培训套图管理-产品
                this.fileList = newVal.filter(item => {
                    item.url = item.trainingUrl
                    item.name = item.trainingName
                    return item
                })
            },
            immediate: true
        }
    },


    mounted() {
    },
    methods: {
        handleSuccess(res, file, fileList) {
            let data = {}
            console.log('??', res, file, fileList)
            data.trainingName = res.data.fileName
            data.trainingUrl = res.data.url
            data.name = res.data.fileName
            data.url = res.data.url
            if (this.limit == 1) {
                this.fileList = [data]
            } else {
                this.fileList.push(data)
            }
            this.emit()
        },
        beforeUpload(file) {
            if (this.accept === 'img') {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
                if (!isJPG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!')
                }
                return isJPG;
            } else if (this.accept === 'doc') {
                // 新增：文档格式校验（包括图片和常见文档类型）
                const isDoc = file.type === 'image/jpeg' ||
                    file.type === 'image/png' ||
                    file.type === 'image/jpg' ||
                    file.type === 'application/pdf' ||
                    file.type === 'application/msword' || // .doc
                    file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // .docx
                    file.type === 'application/vnd.ms-excel' || // .xls
                    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; // .xlsx
                if (!isDoc) {
                    this.$message.error('只能上传图片、文档格式!')
                }
                return isDoc;
            } else if (this.accept === 'video') {
                const isJPG = file.type === 'video/mp4' || file.type === 'video/quicktime' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
                if (!isJPG) {
                    this.$message.error('上传图片视频格式!')
                }
                return isJPG;
            } else {
                return true;
            }
        },
        isImage(url) {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
            const extension = url.split('.').pop().toLowerCase();
            return imageExtensions.includes(extension);
        },
        isVideo(url) {
            const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
            const extension = url.split('.').pop().toLowerCase();
            return videoExtensions.includes(extension);
        },
        isDocument(url) {
            if (!url) return false
            const previewableExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt']
            const ext = url.split('.').pop().toLowerCase()
            return previewableExtensions.includes(ext)
        },
        onPreview(url) {
            if (this.isImage(url)) {
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            } else if (this.isVideo(url)) {
                this.previewVideoUrl = url
                this.dialogVideoVisible = true
            }
        },
        handelRemove(url) {
            // this.fileList = this.fileList.filter(item => item !== url)
            this.fileList = this.fileList.filter(item => item.url !== url)
            this.emit()
        },

        onFilePreview(url) {
            this.previewUrl = url
            this.dialogFileVisible = true
        },
        emit() {
            let urldata = this.fileList
            if (this.limit === 1) {
                if (this.fileList.length === 0) {
                    urldata = null
                } else {
                    urldata = this.fileList[0]
                }

            }
            // console.log('success====:', url, this.type)
            this.$emit('success', urldata, this.type);
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.avatar-uploader-icon:hover {
    border: 1px dashed #409eff;
}

.avatar-uploader-icon {
    border: 1px dashed #c0ccda;
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 140px;
    line-height: 140px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
}

.upload-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    .avatar-uploader{
        padding-bottom: 30px;
    }
}
.item-box{
    padding-bottom: 20px;
    .file-name{
        position: absolute;
        bottom: 2px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        line-height: 24px;
    }
}

.img-box {
    position: relative;

    .img-btn-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        background-color: rgba(0, 0, 0, .5);
        opacity: 0;
        transition: opacity .3s;

        i {
            font-size: 20px;
            color: #fff;
            // margin: 0 20px;
            cursor: pointer;
        }
    }

    &:hover {
        .img-btn-box {
            opacity: 1;
        }
    }
}

.pdf_dialog {
    height: 100vh;

    ::v-deep .el-dialog {
        height: calc(97vh - 52px);
        min-width: 72vw;
        width: 75%;

        .el-dialog__body {
            height: calc(100% - 110px);
        }
    }
}

.icon-delete {
    margin-left: 20px;
}

.file-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px dashed #c0ccda;

    .file-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            width: calc(100% - 60px);
            height: calc(100% - 60px);
        }

        .name {
            //超出换行
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-align: center;

        }
    }

    .file-btn-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, .5);
        opacity: 0;
        transition: opacity .3s;

        i {
            font-size: 20px;
            color: #fff;
            margin: 0 20px;
            cursor: pointer;
        }
    }

    &:hover {
        .file-btn-box {
            opacity: 1;
        }
    }

}
</style>